import React, { Component } from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

import UserActions from '../../actions/UserActionCreator';
import UserStore from '../../stores/UserStore';

class RestoreErrorDialog extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            open: false,
            userId: null,
            email: null
        };
    }

    componentDidMount() {
        this.onError = this.onError.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.listener = UserStore.addRestoreErrorListener(this.onError)
    }

    componentWillUnmount() {
        this.listener.remove();
    }

    render() {

        const closeDialog = () => this.setState({open: false});
        return (
            <Dialog
                title="Restore user"
                open={this.state.open}
                onRequestClose={closeDialog}
                actions={[
                    <FlatButton key="cancel" label="Cancel" onTouchTap={closeDialog}/>,
                    <FlatButton
                        key="save"
                        label="Restore"
                        onTouchTap={this.onSubmit}
                        disabled={!this.state.email}
                        primary
                    />
                ]}
            >
                {this.state.message}. In order to restore this user please supply a different email address.<br/>
                <TextField
                    name="email"
                    hintText="New email address"
                    floatingLabelText="New email address"
                    onChange={(e, value) => this.setState({email: value})}
                />
            </Dialog>
        );
    }

    onError() {
        const error = UserStore.getRestoreError();
        // In absence of error codes, evaluate error message
        if (!!error && !!error.payload.id && error.message.includes('email address') && error.message.includes('currently in use')) {
            this.setState({message: error.message, userId: error.payload.id, open: true});
        }
    }

    onSubmit() {
        UserActions.restoreDeletedUser(this.state.userId, {email: this.state.email});
        this.setState({open: false});
    }
}

export default RestoreErrorDialog;
